import { render, staticRenderFns } from "./ArticleTag.vue?vue&type=template&id=c2fd4228&scoped=true&"
import script from "./ArticleTag.vue?vue&type=script&lang=js&"
export * from "./ArticleTag.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTag.vue?vue&type=style&index=0&id=c2fd4228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fd4228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDivider,VIcon})
